import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCurrency } from '../../../helpers/formatters';
import useApi from '../../../hooks/useApi';
import { CurrencyNumber } from '../../../models/BrandedTypes';
import WalletDigest from '../../../models/wallet/WalletDigest';
import { useMemberStaleAwareData } from '../../Context/useMemberStaleAwareData';
import Icon from '../../common/Icon';
import { NotificationBannerItem } from '../NotificationBanner';

const useCashbackAlert = () => {
  const navigate = useNavigate();
  const { data } = useMemberStaleAwareData();
  const { getApi } = useApi();

  const [wallet, setWallet] = useState<WalletDigest | null>(null);
  const [alerts, setAlerts] = useState<NotificationBannerItem[]>([]);

  const membershipNumber = data?.membershipNumber;

  const loadWallet = useCallback(async () => {
    if (!membershipNumber) {
      setWallet(null);
      return;
    }

    let cancelled = false;

    try {
      const api = await getApi();
      const response = await api
        .url(`/wallets/${membershipNumber}/digest`)
        .get()
        .json<{ data: WalletDigest; errors: string[]; warnings: string[] }>();

      if (!cancelled) {
        setWallet(response.data ?? null);
      }
    } catch {
      if (!cancelled) {
        setWallet(null);
      }
    }

    return () => {
      cancelled = true;
    };
  }, [membershipNumber, getApi]);

  const calculateAlerts = useCallback(
    (wallet: WalletDigest | null): NotificationBannerItem[] => {
    
    if (!wallet|| !Array.isArray(wallet.schemes) || wallet.schemes.length === 0) {
      return [];
    }


      const asCurrencyNumber = (value: number): CurrencyNumber =>
        value as CurrencyNumber;

      const totalCashback: CurrencyNumber = asCurrencyNumber(
        wallet.schemes.reduce(
          (sum, scheme) => sum + scheme.totals.current,
          0
        )
      );

      console.log(totalCashback);


      if (totalCashback === 0) return [];

      return [
        {
          highlight: true,
          highlightOrder: 3,
          status: 'green',
          icon: <Icon name="information" color="#07bc0c" />,
          text: `Cashback available — ${formatCurrency(totalCashback)}`,
          buttonText: 'Claim',
          onButtonClick: () => navigate('/wallet'),
        },
      ];
    },
    [navigate]
  );

  const refresh = useCallback(async () => {
    await loadWallet();
  }, [loadWallet]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    setAlerts(calculateAlerts(wallet));
  }, [wallet, calculateAlerts]);

  return { alerts, refresh };
};

export default useCashbackAlert;